import React from 'react';
export function QuickActions() {
  return <div className="hidden lg:flex items-center gap-3 flex-shrink-0" data-id="element-193">
      <div className="flex flex-col items-end gap-1.5" data-id="element-194">
        <div className="flex items-center gap-3" data-id="element-195">
          <a href="tel:8106297964" className="flex items-center gap-1.5 transition-colors hover:opacity-80" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif',
          fontSize: '13px'
        }} data-id="element-196">
            {/* Phone icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-197">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z" data-id="element-198" />
            </svg>
            (810) 629-7964
          </a>
          <a href="https://www.facebook.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="transition-opacity hover:opacity-80" style={{
          color: '#a0b8a8'
        }} data-id="element-199">
            {/* Facebook icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-200">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-201" />
            </svg>
          </a>
          <a href="https://www.youtube.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="transition-opacity hover:opacity-80" style={{
          color: '#a0b8a8'
        }} data-id="element-202">
            {/* YouTube icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-203">
              <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" data-id="element-204" />
              <path d="m10 15 5-3-5-3z" data-id="element-205" />
            </svg>
          </a>
        </div>
        <a href="/Apply-For-Membership" className="flex items-center gap-1.5 px-5 py-2 rounded text-sm font-semibold transition-all hover:opacity-90 w-full justify-center" style={{
        backgroundColor: '#c8a84b',
        color: '#1a1a1a',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-206">
          {/* UserPlus icon */}
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-207">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" data-id="element-208" />
            <circle cx="9" cy="7" r="4" data-id="element-209" />
            <line x1="19" x2="19" y1="8" y2="14" data-id="element-210" />
            <line x1="22" x2="16" y1="11" y2="11" data-id="element-211" />
          </svg>
          Apply for Membership
        </a>
      </div>
    </div>;
}